export default __webpack_public_path__ + "static/media/hc-1.4f1331ba.mp4";